import store from '../../store';
import * as errActions from '../../redux/errors/actions.errors';

export function dispatchError(error) {
    store.dispatch(errActions.sentError({ error }));
}
